module.exports = '<svg width="40" height="32" viewBox="0 0 40 32"><path d="M16.002 19.994H2.112C1.008 19.994 0 19.102 0 17.998v-4c0-1.104 1.008-2.004 2.112-2.004h13.89V2.637c0-2.48 1.772-3.36 3.772-2l18.754 12.882c2 1.36 1.928 3.6-.032 4.961L19.762 31.362c-1.948 1.36-3.76.48-3.76-2v-9.365z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/right-3.js
// module id = 1379
// module chunks = 14